export default [{
  path: '/Example',
  component: { render: h => h('router-view') },
  meta: { debug: true },
  children: [
    {
      path: '',
      name: 'Example',
      component: () => import('@/components/examples/Example.vue'),
      meta: { debug: true }
    },
    {
      path: 'AllCompsExample',
      name: 'AllCompsExample',
      component: () => import('@/components/examples/AllCompsExample.vue'),
      meta: { debug: true }
    },
    {
      path: 'ConvertImagesPdfExample',
      name: 'ConvertImagesPdfExample',
      component: () => import('@/components/examples/ConvertImagesPdfExample.vue'),
      meta: { debug: true }
    }
  ]
}
]
